/**
 * Created by jonas on 2023-01-11.
 */
import {BS2Symbol, BS2SymbolStates} from "./BS2Symbol";
import {BS2Reel} from "./BS2Reel";
import {gsap} from "gsap";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {SimpleReelModelSymbolPosition} from "../../core/reel/simplereel/SimpleReelModel";
import {WildSpinAnimName} from "../server/BS2Data";

export class WildSymbol extends BS2Symbol {
    private _isVisuallySticky: boolean = false;
    private _isSticky: boolean = false;

    constructor(symbolName: string, initState: BS2SymbolStates, reelsView: BS2Reel, symbolsPosition?: SimpleReelModelSymbolPosition) {
        super(symbolName, initState, reelsView, symbolsPosition);
        this._isVisuallySticky = false;

    }

    public setSticky(value: boolean) {
        this._isSticky = value;
    }

    public removeSpinePreSpin() {
        if (!this._isSticky) {
            super.removeSpinePreSpin();
        }
    }

    getWinHighlightAnimation(): gsap.core.Timeline {
        return super.getWinHighlightAnimation(WildSpinAnimName.WIN_HIGHLIGHT);
    }

    getWinRemoveAnimation(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = super.getWinRemoveAnimation(WildSpinAnimName.WIN);
        tl.add(gsap.to(this._multiplier, {duration: 0.05, alpha: 0, ease: "none"}), ">-0.63");
        return tl;
    }

    getLandingAnimation(): gsap.core.Timeline {
        if (this._isVisuallySticky) {
            return gsap.timeline();
        }
        return super.getLandingAnimation();
    }

    moveToWildLocked(): void {
        super.moveToWildLocked();
    }

    public getStickyAnimation(reelId: number = 0, shallPlaySound: boolean = true): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (this._isVisuallySticky) {
            return tl;
        }
        this._isVisuallySticky = true;
        const spine: PIXI.spine.Spine|undefined = this.getSymbolSpine(this._symbolName);
        if (spine) {
            tl.add(() => {
                this.addSpineToView(spine);
                this.moveToWildLocked();
                SpineGSAPWrapper.createTimeline(spine, 0, WildSpinAnimName.IDLE_ALL, Number.MAX_VALUE);
            });
            tl.add(gsap.to(this._mainSprite, {duration: 0.001, alpha: 0}), "<");
        }
        return tl;
    }

    get isSticky(): boolean {
        return this._isSticky;
    }
}